define('NVT.membershipdirectory.membershipdirectory', [
    'membershipdirectory.View',
    'Utils'
], function (
    membershipdirectoryListView,
    Utils
) {
    'use strict';

    return {
        mountToApp: function (container) {
            var PageType = container.getComponent('PageType');

            PageType.registerPageType({
                name: 'membershipdirectory_list',
                routes: ['membershipdirectory'],
                view: membershipdirectoryListView,
                defaultTemplate: {
                    name: 'membershipdirectory_list.tpl',
                    displayName: 'Membership Directory'
                }
            });

          
            //var MyAccountMenu = container.getComponent('MyAccountMenu');
            var MyAccountMenu = container.getComponent('Application');
            if(MyAccountMenu)
            {
                MyAccountMenu.getComponent().renderHeader();
            }
                
            // var membershipdirectoryListGroupEntry = {
            //     groupid: 'settings',
            //     id: 'membershipdirectorylist',
            //     name: Utils.translate('Membership Directory'),
            //     url: 'membershipdirectory',
            //     index: 99
            // }

            // MyAccountMenu.addGroupEntry(membershipdirectoryListGroupEntry);



              
   

        }
    }
});
